import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import "../../../../../App.css";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../../components/main_comps/custom_date_picker";
import {
  validateEmail,
  validatePan,
} from "../../../../../utility/emailValidator";
import { validateDate } from "@mui/x-date-pickers/internals/hooks/validation/useDateValidation";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

function BasicDetails({
  onClickNext,
  onClickBack,
  onChange,
  reduxData,
  onClickPrevious,
  onClickCancel,
}) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [pan, setPan] = useState("");
  const [currentDate, setCurrentDate] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth() + 1;
    let yyyy = date.getFullYear();

    //Add a zero if one Digit (eg: 05,09)
    if (dd < 10) {
      dd = "0" + dd;
    }

    //Add a zero if one Digit (eg: 05,09)
    if (mm < 10) {
      mm = "0" + mm;
    }
    let maxYear = yyyy - 18;
    let max = maxYear + "-" + mm + "-" + dd;

    setCurrentDate(max);
  }, []);

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };
  const datePickerStyle = {
    maxWidth: 500,
    minWidth: "343px",
    width: 343,
    height: "45px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    // padding: 0,
    border: null,
    margin: "5px 0 20px 0",

    // paddingBottom: "20px",
  };

  const inputStyleDatePicker = {
    height: "48px",
    borderColor: null,
    border: null,
    // padding: "0 0 -10px 0",
    padding: "10px",
  };
  const hoveringStyleDatePicker = {
    borderColor: null,
    border: null,
    outline: "none",
  };

  useEffect(() => {
    if (
      reduxData?.firstName &&
      reduxData?.lastName &&
      reduxData?.email &&
      reduxData?.mobileNumber &&
      reduxData?.panNumber &&
      reduxData?.dateOfBirth
    ) {
      setFirstName(reduxData?.firstName);
      setLastName(reduxData?.lastName);
      setEmail(reduxData?.email);
      setMobileNumber(reduxData?.mobileNumber);
      setDateOfBirth(reduxData?.dateOfBirth);
      setPan(reduxData?.panNumber);
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        height: "100%",
        marginTop: "20px",
      }}
    >
      <p style={styles.title}>Basic Information</p>
      <p style={styles.p}>Provide the basic details of the client</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C",
        }}
      ></div>
      <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>First Name</label>
          <CustomInput
            value={firstName}
            onChange={(data) => setFirstName(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="First Name"
            validator="name"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Last Name</label>
          <CustomInput
            value={lastName}
            onChange={(data) => setLastName(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Last Name"
            validator="name"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Mobile Number</label>
          <CustomInput
            value={mobileNumber}
            onChange={(data) => setMobileNumber(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Mobile Number"
            validator="mobile"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Email</label>
          <CustomInput
            value={email}
            onChange={(data) => setEmail(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Email"
            validator="email"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Date of birth</label>
          <CustomDatePicker
            value={dateOfBirth}
            onChange={(data) => {
              setDateOfBirth(data);
            }}
            autocomplete="off"
            maxDate={currentDate}
            containerStyle={{
              background: "white",
              ...datePickerStyle,
            }}
            fieldHoverStyles={{ ...hoveringStyleDatePicker }}
            inputStyles={{ ...inputStyleDatePicker }}
            placeholder="Date of birth"
            validator="date"
            type="date"
            inputsStyles={{
              padding: "10px",
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Enter PAN</label>
          <CustomInput
            value={pan}
            onChange={(data) => {
              setPan(data);
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="PAN"
            validator="pan"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      </div>
      <div style={{ display: "flex", maxWidth: "340px", marginBottom: "30px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 40px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
              if (
                firstName !== "" &&
                lastName !== "" &&
                mobileNumber.length === 10 &&
                validateEmail(email) &&
                dateOfBirth &&
                panRegex.test(pan)
              ) {
                onClickNext({
                  firstName: firstName,
                  lastName: lastName,
                  mobileNumber,
                  panNumber: pan,
                  email: email,
                  dateOfBirth: dateOfBirth?.toString(),
                });
              } else {
                if (firstName === "") {
                  enqueueSnackbar("Please enter first name", {
                    variant: "error",
                  });
                } else if (lastName === "") {
                  enqueueSnackbar("Please enter last name", {
                    variant: "error",
                  });
                } else if (mobileNumber.length < 10) {
                  enqueueSnackbar("Please enter a valid mobile number", {
                    variant: "error",
                  });
                } else if (!validateEmail(email)) {
                  enqueueSnackbar("Please enter a valid email", {
                    variant: "error",
                  });
                } else if (dateOfBirth === "") {
                  enqueueSnackbar("Please Select Date of Birth", {
                    variant: "error",
                  });
                } else {
                  enqueueSnackbar("Please enter a valid Pan", {
                    variant: "error",
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default BasicDetails;

const styles = {
  title: {
    fontSize: "24px",

    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
};
